import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { maakHouder } from '../api/api';
import AdresAutocomplete from '../components/AdresAutocomplete';

export default function HouderNieuw() {
  const navigate = useNavigate();
  const [type, setType] = useState('RP');
  const [form, setForm] = useState({
    naam: '', voornaam: '', tussenvoegsel: '', achternaam: '',
    kvk_nummer: '', adres: '', postcode: '', plaats: '', land: 'Nederland',
    emailadres: '', telefoonnummer: '', opmerkingen: '',
  });
  const [error, setError] = useState(null);
  const [bezig, setBezig] = useState(false);

  const update = (k, v) => setForm({ ...form, [k]: v });

  const opslaan = async () => {
    setError(null);
    setBezig(true);
    try {
      const data = { type, ...form };
      Object.keys(data).forEach(k => { if (data[k] === '') data[k] = null; });
      const res = await maakHouder(data);
      navigate(`/beregening/houders/${res.data.houder_id}`);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="main-inner">
      <div className="page-header">
        <div>
          <h1 className="page-title">Nieuwe houder</h1>
          <p className="page-subtitle">Bedrijf of natuurlijke persoon</p>
        </div>
        <div className="row">
          <button className="btn btn-ghost" onClick={() => navigate('/beregening/houders')}>Annuleren</button>
          <button className="btn btn-primary" onClick={opslaan} disabled={bezig}>
            {bezig ? <><span className="spinner" /> Opslaan...</> : 'Opslaan'}
          </button>
        </div>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="card">
        <div className="card-header"><h3 className="card-title">Type houder</h3></div>
        <div className="choices">
          <label className={`choice ${type === 'RP' ? 'selected' : ''}`}>
            <input type="radio" name="type" checked={type === 'RP'} onChange={() => setType('RP')} />
            <span className="choice-check" />
            <span className="choice-title">Rechtspersoon</span>
            <span className="choice-sub">Bedrijf, maatschap, stichting</span>
          </label>
          <label className={`choice ${type === 'NP' ? 'selected' : ''}`}>
            <input type="radio" name="type" checked={type === 'NP'} onChange={() => setType('NP')} />
            <span className="choice-check" />
            <span className="choice-title">Natuurlijke persoon</span>
            <span className="choice-sub">Particulier zonder KvK</span>
          </label>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><h3 className="card-title">Identificatie</h3></div>
        <div className="field-grid">
          {type === 'RP' ? (
            <>
              <div className="field">
                <label className="field-label">Bedrijfsnaam</label>
                <input value={form.naam} onChange={(e) => update('naam', e.target.value)} />
              </div>
              <div className="field">
                <label className="field-label">KvK-nummer</label>
                <input value={form.kvk_nummer} onChange={(e) => update('kvk_nummer', e.target.value)} maxLength={8} />
              </div>
            </>
          ) : (
            <>
              <div className="field">
                <label className="field-label">Voornaam</label>
                <input value={form.voornaam} onChange={(e) => update('voornaam', e.target.value)} />
              </div>
              <div className="field">
                <label className="field-label">Tussenvoegsel</label>
                <input value={form.tussenvoegsel} onChange={(e) => update('tussenvoegsel', e.target.value)} />
              </div>
              <div className="field">
                <label className="field-label">Achternaam</label>
                <input value={form.achternaam} onChange={(e) => update('achternaam', e.target.value)} />
              </div>
            </>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Adres</h3>
          <span style={{ flex: 1 }} />
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => {
              const naarBelgie = form.land !== 'België';
              setForm({
                ...form,
                land: naarBelgie ? 'België' : 'Nederland',
                adres: '', postcode: '', plaats: '',
              });
            }}
          >
            {form.land === 'België' ? '← Adres in Nederland' : 'Adres in België?'}
          </button>
        </div>
        <div className="field-grid cols-3">
          <div className="field">
            <label className="field-label">Adres</label>
            {form.land === 'Nederland' ? (
              <AdresAutocomplete
                value={form.adres}
                onChange={(v) => update('adres', v)}
                onSelected={({ adres, postcode, plaats }) => {
                  setForm({ ...form, adres, postcode, plaats });
                }}
              />
            ) : (
              <input value={form.adres} onChange={(e) => update('adres', e.target.value)} />
            )}
          </div>
          <div className="field">
            <label className="field-label">Postcode</label>
            <input value={form.postcode} onChange={(e) => update('postcode', e.target.value)} />
          </div>
          <div className="field">
            <label className="field-label">Plaats</label>
            <input value={form.plaats} onChange={(e) => update('plaats', e.target.value)} />
          </div>
        </div>
        {form.land === 'België' && (
          <p style={{ fontSize: 12, color: 'var(--text-muted)', margin: '8px 0 0 0' }}>
            Belgisch adres — handmatige invoer
          </p>
        )}
      </div>

      <div className="card">
        <div className="card-header"><h3 className="card-title">Contact</h3></div>
        <div className="field-grid">
          <div className="field">
            <label className="field-label">E-mailadres</label>
            <input type="email" value={form.emailadres} onChange={(e) => update('emailadres', e.target.value)} />
          </div>
          <div className="field">
            <label className="field-label">Telefoonnummer</label>
            <input value={form.telefoonnummer} onChange={(e) => update('telefoonnummer', e.target.value)} />
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><h3 className="card-title">Opmerkingen</h3></div>
        <textarea rows={4} value={form.opmerkingen} onChange={(e) => update('opmerkingen', e.target.value)} />
      </div>
    </div>
  );
}
